import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { fetchGet } from '@epi-helpers/FetchHelpers';
import { showNotification } from '@epi-actions/overlays';
import { genericErrorMessage } from '@epi-constants/downloadReports';
import { companyBenefitsGroupSetting } from '@epi-repositories/BenefitGroupSettingsRepository';
import { IAvailableBenefits } from '@epi-models/containers/ManageBenefits';
import { ACTIVE, INACTIVE, LUNCH } from '@epi-constants/benefitTypes';

export const useManageBenefits = () => {
  const dispatch = useDispatch();
  const [availableBenefits, setAvailableBenefits] = useState<
    IAvailableBenefits[]
  >([]);
  const [allBenefits, setAllBenefits] = useState<IAvailableBenefits[]>([]);

  const onSuccess = (data: IAvailableBenefits[]) => {
    const active = data.filter(elem => elem.state === ACTIVE);
    const inActive = data.filter(elem => elem.state === INACTIVE);
    setAvailableBenefits([...inActive, ...active]);
    setAllBenefits([...data]);
  };

  const onFailure = err => {
    dispatch(showNotification({ message: genericErrorMessage }, 'error'));
  };

  const refetchAvailableBenefits = useCallback(() => {
    fetchGet(companyBenefitsGroupSetting(), {}, onSuccess, onFailure);
  }, []);

  useEffect(() => {
    refetchAvailableBenefits();
  }, [refetchAvailableBenefits]);

  const isLunchBenefitActive =
    allBenefits.find(benefit => benefit.type === LUNCH)?.state === ACTIVE;

  const { activeAvailableBenefits, inactiveAvailableBenefits } =
    availableBenefits.reduce<{
      activeAvailableBenefits: IAvailableBenefits[];
      inactiveAvailableBenefits: IAvailableBenefits[];
    }>(
      (acc, benefit) => {
        acc[
          benefit.state === ACTIVE
            ? 'activeAvailableBenefits'
            : 'inactiveAvailableBenefits'
        ].push(benefit);
        return acc;
      },
      { activeAvailableBenefits: [], inactiveAvailableBenefits: [] }
    );

  return {
    availableBenefits,
    allBenefits,
    activeAvailableBenefits,
    inactiveAvailableBenefits,
    isLunchBenefitActive,
    refetchAvailableBenefits
  };
};
